module.exports = __webpack_public_path__ + "img/topUpBg.47796538.png";